var _defs, _ellipse, _ellipse2, _ellipse3, _g, _ellipse4, _path, _text, _text2, _path2, _text3, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _text4, _text5, _text6, _text7, _text8, _g12, _text9, _text0, _text1, _text10, _text11, _g13, _text12, _text13, _text14, _text15, _text16, _g14, _text17, _text18, _text19, _text20, _text21, _g15, _text22, _text23, _text24, _text25, _text26, _g16, _ellipse5, _ellipse6, _text27, _text28, _text29;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowItWorksFlow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 460",
    width: 1200,
    height: 460,
    role: "img",
    "aria-label": "BossDrop's governed pipeline: connect tools, detect risks and blockers, decide with a plan and critic, get approval on high-impact actions, execute, and close the loop with a full audit trail",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "hAmbient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.22,
    fy: 0.26
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7161b2",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#5d5094",
    stopOpacity: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#4c4380",
    stopOpacity: 0.092
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#453c74",
    stopOpacity: 0.034
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3f3769",
    stopOpacity: 0.009
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3769",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hRowGlow",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.36,
    fy: 0.42
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7a4e6",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#b7a4e6",
    stopOpacity: 0.135
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#8f7fd0",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8f7fd0",
    stopOpacity: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hKey",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.18,
    fy: 0.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efe9fa",
    stopOpacity: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#cfc3ee",
    stopOpacity: 0.042
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#cfc3ee",
    stopOpacity: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfc3ee",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hFloorFade",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.3,
    fy: 0.34
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fff",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fff",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hFloorPlane",
    x1: 0.05,
    y1: 0,
    x2: 0.62,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efe9fa",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#b7a4e6",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#7e70c0",
    stopOpacity: 0.055
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3a3160",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211b3d",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("mask", {
    id: "hFloorMask"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 604,
    cy: 336,
    rx: 576,
    ry: 104,
    fill: "url(#hFloorFade)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hFloorPool",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.26,
    fy: 0.34
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6ddfa",
    stopOpacity: 0.095
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#cfc3ee",
    stopOpacity: 0.038
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#b7a4e6",
    stopOpacity: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7a4e6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hRim",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfc3ee",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#efe9fa",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#cfc3ee",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#b7a4e6",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#9d8fd6",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9d8fd6",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d8fd6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hContact",
    cx: 0.42,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07050f",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#07050f",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#07050f",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07050f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hContactTight",
    cx: 0.45,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#050310",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#050310",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050310",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hCardFace",
    x1: 0.08,
    y1: 0,
    x2: 0.62,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c3664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#241f3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15121f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hCardFaceOk",
    x1: 0.08,
    y1: 0,
    x2: 0.62,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#213f2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#142518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c1610"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hFaceSheen",
    cx: 0.5,
    cy: 0.5,
    r: 0.6,
    fx: 0.18,
    fy: 0.12
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8cef4",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#b7a4e6",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7a4e6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hFaceSheenOk",
    cx: 0.5,
    cy: 0.5,
    r: 0.6,
    fx: 0.18,
    fy: 0.12
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bff3d9",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#a7f3d0",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7f3d0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hTopHi",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffffff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hBevel",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6ddfa",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#cfc3ee",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfc3ee",
    stopOpacity: 0.015
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hSideHi",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 146,
    x2: 0,
    y2: 280
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6ddfa",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e6ddfa",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6ddfa",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hSideDark",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 150,
    x2: 0,
    y2: 300
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05040c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#05040c",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05040c",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hUnder",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#090714",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#090714",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090714",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hWellFace",
    x1: 0.2,
    y1: 0,
    x2: 0.8,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15121f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#211c36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#342d56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hWellFaceOk",
    x1: 0.2,
    y1: 0,
    x2: 0.8,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c1610"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#132318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c3827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hflow",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hflowRun",
    gradientUnits: "userSpaceOnUse",
    x1: 250,
    y1: 205,
    x2: 960,
    y2: 205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b7a4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hgold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff7cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2b24a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hBandLens",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.4,
    fy: 0.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff7cb",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f3dfa2",
    stopOpacity: 0.085
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#e2b24a",
    stopOpacity: 0.025
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2b24a",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hBandHot",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fx: 0.42,
    fy: 0.38
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff7cb",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff7cb",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff7cb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("marker", {
    id: "harrow",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#b7a4e6"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "harrowDim",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#7f70c0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hLiftCard",
    x: "-14%",
    y: "-30%",
    width: "132%",
    height: "200%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2.3,
    stdDeviation: 2,
    floodColor: "#08061a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 5,
    dy: 11,
    stdDeviation: 9,
    floodColor: "#08061a",
    floodOpacity: 0.42
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 10,
    dy: 23,
    stdDeviation: 18,
    floodColor: "#08061a",
    floodOpacity: 0.3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hLiftIcon",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "240%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2.3,
    stdDeviation: 1.6,
    floodColor: "#08061a",
    floodOpacity: 0.55
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 3,
    dy: 7,
    stdDeviation: 6,
    floodColor: "#08061a",
    floodOpacity: 0.34
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hTextSh",
    x: "-10%",
    y: "-60%",
    width: "130%",
    height: "260%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 1.5,
    stdDeviation: 2.6,
    floodColor: "#0b0918",
    floodOpacity: 0.62
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hLineGlow",
    filterUnits: "userSpaceOnUse",
    x: 230,
    y: 170,
    width: 770,
    height: 70,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 4,
    floodColor: "#b7a4e6",
    floodOpacity: 0.45
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2.3,
    stdDeviation: 2,
    floodColor: "#08061a",
    floodOpacity: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hArcGlow",
    x: "-10%",
    y: "-40%",
    width: "120%",
    height: "180%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 5,
    floodColor: "#8f7fd0",
    floodOpacity: 0.3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hRimBlur",
    x: "-10%",
    y: "-500%",
    width: "120%",
    height: "1100%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  })), /*#__PURE__*/React.createElement("style", null, "\n      .ht { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#f4f0fc; }\n      /* the subtitle sits on the washes alone now that the panel is gone, so it\n         is lighter than the type that sits on the dark slab faces: #c3bdd6\n         clears 4.5:1 even over the brightest part of the key wash */\n      .hs { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:600; fill:#c3bdd6; }\n      .hl { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#efe9fa; }\n      .hsub { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:500; fill:#aaa4bd; }\n      .hloop { fill:#bdb7d0; }\n      .hk { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#8fd8f0; }\n      .hband { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:600; fill:#f5e3ab; }\n      /* the stacked variants exist only for the narrow widths, where one long\n         line of this type would be unreadable. Same words, two lines. */\n      .hsub2 { display:none; }\n      .hbandtwo { display:none; }\n\n      /* ===== Tablets and small laptops =====\n         An image-referenced SVG evaluates media queries against its own rendered\n         width. The page shows this figure at min(992, viewport - 48)px, so\n         without this step everything between 561 and 880px got desktop type at a\n         sub-desktop scale and the sub-labels fell to 5.9px. Here the type steps\n         up and the sub-labels break to two lines, which is what lets them grow\n         inside a 180-unit slab. */\n      @media (max-width: 880px) {\n        .ht { font-size:32px; }\n        .hs { font-size:20px; }\n        .hcard { height:176px; }\n        .hnum  { font-size:21px; }\n        .hlabel{ font-size:24px; transform:translateY(4px); }\n        .hsub1 { display:none; }\n        .hsub2 { display:inline; font-size:19px; }\n        .hunder { transform:translateY(26px); }\n        .hcheek line { y2:292px; stroke-width:2; }\n        .hterm  line { y2:290px; stroke-width:2; }\n        .htop { stroke-width:2; }\n        .hbev { stroke-width:6; }\n        .hcontact { cy:312px; }\n        .hcontact2 { cy:310px; }\n        .hloopArc { d:path(\"M1048 314 C 1048 384, 382 384, 382 313\"); }\n        .hloop { font-size:19px; transform:translateY(14px); }\n        .hband { font-size:20px; }\n      }\n\n      /* ===== Phone =====\n         Fires at the ~343px the page shows on a phone, where the desktop 13.5px\n         type would land at 3.9px. Type grows to what the artboard can hold, the\n         slabs grow with it, and every stacked pair is opened up until there are\n         blank pixel rows between the lines at 1x. Geometry only. */\n      @media (max-width: 560px) {\n        /* the title keeps 11 units of headroom so its own shadow never reaches\n           the artboard edge */\n        .ht { font-size:44px; transform:translateY(-14px); }\n        .hs { font-size:28px; }\n\n        .hcard { y:104px; height:212px; }\n        .hnum  { font-size:30px; transform:translateY(-32px); }\n        .hlabel{ font-size:36px; transform:translateY(-4px); }\n        .hsub1 { display:none; }\n        /* secondary type is lightened at this size: 8px of #aaa4bd on a dark\n           slab is technically present and practically invisible */\n        .hsub2 { display:inline; font-size:28px; fill:#c3bdd6; }\n        .hsub2a { transform:translateY(2px); }\n        .hsub2b { transform:translateY(14px); }\n        .hwell { cy:166px; r:28px; }\n        .hicon { transform:translateY(-6px); }\n        .hcontact { cy:322px; rx:102px; }\n        .hcontact2 { cy:320px; }\n        /* the cues that survive a 0.29x downscale: the lit left cheek and the\n           dark right cheek, both thickened. The 1px top arc, underside and well\n           rims are a third of a pixel here and only muddy it. */\n        .htop, .hbev, .hunder, .hwellrim { display:none; }\n        .hcheek line { y1:120px; y2:300px; stroke-width:3; }\n        .hterm  line { y1:130px; y2:300px; stroke-width:3; }\n\n        /* both runs are thickened so a 2.5-unit stroke does not become 0.7px */\n        .hloopArc { d:path(\"M1048 322 C 1048 342, 382 342, 382 321\"); stroke-width:4; stroke-dasharray:12 11; }\n        .hrun { stroke-width:4; }\n        /* at 8px the text shadow only thickens the glyphs and steals the gap to\n           the band below, and the caption clears 6.6:1 on the floor without it */\n        .hloop { font-size:28px; fill:#c3bdd6; transform:translateY(-10px); filter:none; }\n\n        .hlens { cy:424px; ry:34px; }\n        .hlensHot { cy:420px; ry:24px; }\n        .hbandone { display:none; }\n        .hbandtwo { display:inline; font-size:28px; }\n      }\n    "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 230,
    rx: 584,
    ry: 222,
    fill: "url(#hAmbient)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 604,
    cy: 214,
    rx: 548,
    ry: 146,
    fill: "url(#hRowGlow)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 470,
    cy: 200,
    rx: 456,
    ry: 192,
    fill: "url(#hKey)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#hFloorMask)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 232,
    width: 1152,
    height: 208,
    fill: "url(#hFloorPlane)"
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 540,
    cy: 326,
    rx: 480,
    ry: 86,
    fill: "url(#hFloorPool)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 268 A466 26 0 0 1 1048 268",
    fill: "none",
    stroke: "url(#hRim)",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    filter: "url(#hRimBlur)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 58,
    className: "ht",
    fontSize: 26,
    filter: "url(#hTextSh)"
  }, "A governed loop, not a black box")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 88,
    className: "hs",
    fontSize: 16,
    filter: "url(#hTextSh)"
  }, "Every step is scoped, approved where it matters, and written to an audit log.")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "hloopArc",
    d: "M1048 288 C 1048 372, 382 372, 382 287",
    fill: "none",
    stroke: "#7f70c0",
    strokeWidth: 2.5,
    strokeDasharray: "7 8",
    strokeLinecap: "round",
    opacity: 0.8,
    markerEnd: "url(#harrowDim)",
    filter: "url(#hArcGlow)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 715,
    y: 374,
    textAnchor: "middle",
    className: "hsub hloop",
    fontSize: 13.5,
    filter: "url(#hTextSh)"
  }, "Close the loop: track outcomes &amp; learn")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "hcontact",
    cx: 164,
    cy: 286,
    rx: 100,
    ry: 11,
    fill: "url(#hContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "hcontact",
    cx: 389,
    cy: 286,
    rx: 102,
    ry: 11,
    fill: "url(#hContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "hcontact",
    cx: 614,
    cy: 286,
    rx: 104,
    ry: 11,
    fill: "url(#hContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "hcontact",
    cx: 839,
    cy: 286,
    rx: 106,
    ry: 11,
    fill: "url(#hContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "hcontact",
    cx: 1064,
    cy: 286,
    rx: 108,
    ry: 11,
    fill: "url(#hContact)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "hcontact2",
    cx: 162,
    cy: 283,
    rx: 76,
    ry: 7,
    fill: "url(#hContactTight)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "hcontact2",
    cx: 386,
    cy: 283,
    rx: 76,
    ry: 7,
    fill: "url(#hContactTight)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "hcontact2",
    cx: 610,
    cy: 283,
    rx: 76,
    ry: 7,
    fill: "url(#hContactTight)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "hcontact2",
    cx: 834,
    cy: 283,
    rx: 76,
    ry: 7,
    fill: "url(#hContactTight)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "hcontact2",
    cx: 1058,
    cy: 283,
    rx: 76,
    ry: 7,
    fill: "url(#hContactTight)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#hLiftCard)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "hcard",
    x: 70,
    y: 130,
    width: 180,
    height: 150,
    rx: 16,
    fill: "url(#hCardFace)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "hcard",
    x: 292,
    y: 130,
    width: 180,
    height: 150,
    rx: 16,
    fill: "url(#hCardFace)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "hcard",
    x: 514,
    y: 130,
    width: 180,
    height: 150,
    rx: 16,
    fill: "url(#hCardFace)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "hcard",
    x: 736,
    y: 130,
    width: 180,
    height: 150,
    rx: 16,
    fill: "url(#hCardFaceOk)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "hcard",
    x: 958,
    y: 130,
    width: 180,
    height: 150,
    rx: 16,
    fill: "url(#hCardFace)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "hcard",
    x: 70,
    y: 130,
    width: 180,
    height: 150,
    rx: 16,
    fill: "url(#hFaceSheen)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "hcard",
    x: 292,
    y: 130,
    width: 180,
    height: 150,
    rx: 16,
    fill: "url(#hFaceSheen)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "hcard",
    x: 514,
    y: 130,
    width: 180,
    height: 150,
    rx: 16,
    fill: "url(#hFaceSheen)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "hcard",
    x: 736,
    y: 130,
    width: 180,
    height: 150,
    rx: 16,
    fill: "url(#hFaceSheenOk)",
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "hcard",
    x: 958,
    y: 130,
    width: 180,
    height: 150,
    rx: 16,
    fill: "url(#hFaceSheen)",
    opacity: 0.68
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "hbev",
    fill: "none",
    stroke: "url(#hBevel)",
    strokeWidth: 5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5 146 A13.5 13.5 0 0 1 86 132.5 L234 132.5 A13.5 13.5 0 0 1 247.5 146",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.5 146 A13.5 13.5 0 0 1 308 132.5 L456 132.5 A13.5 13.5 0 0 1 469.5 146",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.5 146 A13.5 13.5 0 0 1 530 132.5 L678 132.5 A13.5 13.5 0 0 1 691.5 146",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.5 146 A13.5 13.5 0 0 1 752 132.5 L900 132.5 A13.5 13.5 0 0 1 913.5 146",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.5 146 A13.5 13.5 0 0 1 974 132.5 L1122 132.5 A13.5 13.5 0 0 1 1135.5 146",
    opacity: 0.63
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "htop",
    fill: "none",
    stroke: "url(#hTopHi)",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9 146 A15.1 15.1 0 0 1 86 130.9 L234 130.9 A15.1 15.1 0 0 1 249.1 146",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.9 146 A15.1 15.1 0 0 1 308 130.9 L456 130.9 A15.1 15.1 0 0 1 471.1 146",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.9 146 A15.1 15.1 0 0 1 530 130.9 L678 130.9 A15.1 15.1 0 0 1 693.1 146",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.9 146 A15.1 15.1 0 0 1 752 130.9 L900 130.9 A15.1 15.1 0 0 1 915.1 146",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.9 146 A15.1 15.1 0 0 1 974 130.9 L1122 130.9 A15.1 15.1 0 0 1 1137.1 146",
    opacity: 0.63
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "hcheek",
    stroke: "url(#hSideHi)",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 70.9,
    y1: 148,
    x2: 70.9,
    y2: 252,
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.9,
    y1: 148,
    x2: 292.9,
    y2: 252,
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 514.9,
    y1: 148,
    x2: 514.9,
    y2: 252,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 736.9,
    y1: 148,
    x2: 736.9,
    y2: 252,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 958.9,
    y1: 148,
    x2: 958.9,
    y2: 252,
    opacity: 0.63
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "hterm",
    stroke: "url(#hSideDark)",
    strokeWidth: 1.6,
    strokeLinecap: "butt"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 248,
    y1: 152,
    x2: 248,
    y2: 264
  }), /*#__PURE__*/React.createElement("line", {
    x1: 470,
    y1: 152,
    x2: 470,
    y2: 264
  }), /*#__PURE__*/React.createElement("line", {
    x1: 692,
    y1: 152,
    x2: 692,
    y2: 264
  }), /*#__PURE__*/React.createElement("line", {
    x1: 914,
    y1: 152,
    x2: 914,
    y2: 264
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1136,
    y1: 152,
    x2: 1136,
    y2: 264
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "hunder",
    fill: "none",
    stroke: "url(#hUnder)",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 264 A15.1 15.1 0 0 0 87.1 279.1 L232.9 279.1 A15.1 15.1 0 0 0 248 264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294 264 A15.1 15.1 0 0 0 309.1 279.1 L454.9 279.1 A15.1 15.1 0 0 0 470 264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 264 A15.1 15.1 0 0 0 531.1 279.1 L676.9 279.1 A15.1 15.1 0 0 0 692 264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738 264 A15.1 15.1 0 0 0 753.1 279.1 L898.9 279.1 A15.1 15.1 0 0 0 914 264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 264 A15.1 15.1 0 0 0 975.1 279.1 L1120.9 279.1 A15.1 15.1 0 0 0 1136 264"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "hwell",
    cx: 160,
    cy: 172,
    r: 30,
    fill: "url(#hWellFace)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "hwell",
    cx: 382,
    cy: 172,
    r: 30,
    fill: "url(#hWellFace)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "hwell",
    cx: 604,
    cy: 172,
    r: 30,
    fill: "url(#hWellFace)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "hwell",
    cx: 826,
    cy: 172,
    r: 30,
    fill: "url(#hWellFaceOk)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "hwell",
    cx: 1048,
    cy: 172,
    r: 30,
    fill: "url(#hWellFace)"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "hwellrim",
    fill: "none",
    stroke: "#0c0a16",
    strokeOpacity: 0.55,
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.6 162 A29.2 29.2 0 0 1 187.4 162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.6 162 A29.2 29.2 0 0 1 409.4 162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.6 162 A29.2 29.2 0 0 1 631.4 162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.6 162 A29.2 29.2 0 0 1 853.4 162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.6 162 A29.2 29.2 0 0 1 1075.4 162"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "hwellrim",
    fill: "none",
    stroke: "#cfc3ee",
    strokeOpacity: 0.3,
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.6 182 A29.2 29.2 0 0 0 187.4 182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.6 182 A29.2 29.2 0 0 0 409.4 182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.6 182 A29.2 29.2 0 0 0 631.4 182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.6 182 A29.2 29.2 0 0 0 853.4 182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.6 182 A29.2 29.2 0 0 0 1075.4 182"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "hicon",
    filter: "url(#hLiftIcon)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,172)",
    stroke: "url(#hflow)",
    strokeWidth: 4,
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16 8 a12 12 0 0 1 0 -17 l6 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 -8 a12 12 0 0 1 0 17 l-6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6 6 L6 -6"
  })))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 166,
    className: "hk hnum",
    fontSize: 15
  }, "01")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 234,
    textAnchor: "middle",
    className: "hl hlabel",
    fontSize: 17
  }, "Connect")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 257,
    textAnchor: "middle",
    className: "hsub hsub1",
    fontSize: 13.5
  }, "Your tools &amp; chat")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 264,
    textAnchor: "middle",
    className: "hsub hsub2 hsub2a",
    fontSize: 13.5
  }, "Your tools")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 290,
    textAnchor: "middle",
    className: "hsub hsub2 hsub2b",
    fontSize: 13.5
  }, "&amp; chat")), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "hicon",
    filter: "url(#hLiftIcon)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 172,
    r: 15,
    fill: "none",
    stroke: "url(#hflow)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 172,
    r: 7,
    fill: "none",
    stroke: "url(#hflow)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 172,
    r: 2.5,
    fill: "#8fd8f0"
  }))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 312,
    y: 166,
    className: "hk hnum",
    fontSize: 15
  }, "02")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 234,
    textAnchor: "middle",
    className: "hl hlabel",
    fontSize: 17
  }, "Detect")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 257,
    textAnchor: "middle",
    className: "hsub hsub1",
    fontSize: 13.5
  }, "Risks &amp; blockers")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 264,
    textAnchor: "middle",
    className: "hsub hsub2 hsub2a",
    fontSize: 13.5
  }, "Risks")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 290,
    textAnchor: "middle",
    className: "hsub hsub2 hsub2b",
    fontSize: 13.5
  }, "&amp; blockers")), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "hicon",
    filter: "url(#hLiftIcon)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595 172 L609 162 M595 172 L609 182",
    stroke: "url(#hflow)",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 590,
    cy: 172,
    r: 5,
    fill: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 614,
    cy: 162,
    r: 5,
    fill: "#8f7fd0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 614,
    cy: 182,
    r: 5,
    fill: "#8f7fd0"
  }))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 534,
    y: 166,
    className: "hk hnum",
    fontSize: 15
  }, "03")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 604,
    y: 234,
    textAnchor: "middle",
    className: "hl hlabel",
    fontSize: 17
  }, "Decide")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 604,
    y: 257,
    textAnchor: "middle",
    className: "hsub hsub1",
    fontSize: 13.5
  }, "Plan + critic")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 604,
    y: 264,
    textAnchor: "middle",
    className: "hsub hsub2 hsub2a",
    fontSize: 13.5
  }, "Plan")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 604,
    y: 290,
    textAnchor: "middle",
    className: "hsub hsub2 hsub2b",
    fontSize: 13.5
  }, "+ critic")), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "hicon",
    filter: "url(#hLiftIcon)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 172,
    r: 18,
    fill: "rgba(134,239,172,.14)",
    stroke: "#86efac",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818 173 L824 180 L835 165",
    stroke: "#86efac",
    strokeWidth: 3.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 166,
    className: "hk hnum",
    fontSize: 15,
    fill: "#86efac"
  }, "04")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 826,
    y: 234,
    textAnchor: "middle",
    className: "hl hlabel",
    fontSize: 17
  }, "Approve")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 826,
    y: 257,
    textAnchor: "middle",
    className: "hsub hsub1",
    fontSize: 13.5
  }, "You, when it matters")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 826,
    y: 264,
    textAnchor: "middle",
    className: "hsub hsub2 hsub2a",
    fontSize: 13.5
  }, "You, when it")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 826,
    y: 290,
    textAnchor: "middle",
    className: "hsub hsub2 hsub2b",
    fontSize: 13.5
  }, "matters")), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "hicon",
    filter: "url(#hLiftIcon)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 172,
    r: 17,
    fill: "none",
    stroke: "url(#hgold)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042 164 L1057 172 L1042 180 z",
    fill: "url(#hgold)"
  }))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 978,
    y: 166,
    className: "hk hnum",
    fontSize: 15,
    fill: "#9db4ff"
  }, "05")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 1048,
    y: 234,
    textAnchor: "middle",
    className: "hl hlabel",
    fontSize: 17
  }, "Execute")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 1048,
    y: 257,
    textAnchor: "middle",
    className: "hsub hsub1",
    fontSize: 13.5
  }, "Tasks, pings, meetings")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 1048,
    y: 264,
    textAnchor: "middle",
    className: "hsub hsub2 hsub2a",
    fontSize: 13.5
  }, "Tasks, pings,")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 1048,
    y: 290,
    textAnchor: "middle",
    className: "hsub hsub2 hsub2b",
    fontSize: 13.5
  }, "meetings")), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "hrun",
    stroke: "url(#hflowRun)",
    strokeWidth: 3,
    strokeLinecap: "round",
    filter: "url(#hLineGlow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 256,
    y1: 205,
    x2: 286,
    y2: 205,
    markerEnd: "url(#harrow)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 478,
    y1: 205,
    x2: 508,
    y2: 205,
    markerEnd: "url(#harrow)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 205,
    x2: 730,
    y2: 205,
    markerEnd: "url(#harrow)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 922,
    y1: 205,
    x2: 952,
    y2: 205,
    markerEnd: "url(#harrow)"
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "hlens",
    cx: 604,
    cy: 412,
    rx: 556,
    ry: 32,
    fill: "url(#hBandLens)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "hlensHot",
    cx: 556,
    cy: 408,
    rx: 340,
    ry: 20,
    fill: "url(#hBandHot)"
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 604,
    y: 417,
    textAnchor: "middle",
    className: "hband hbandone",
    fontSize: 14,
    filter: "url(#hTextSh)"
  }, "Scoped permissions  \u2022  approvals on high-impact actions  \u2022  every action written to the audit log")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 604,
    y: 402,
    textAnchor: "middle",
    className: "hband hbandtwo",
    fontSize: 14,
    filter: "url(#hTextSh)"
  }, "Scoped permissions  \u2022  approvals on high-impact actions  \u2022")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 604,
    y: 442,
    textAnchor: "middle",
    className: "hband hbandtwo",
    fontSize: 14,
    filter: "url(#hTextSh)"
  }, "every action written to the audit log")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksFlow);
export default __webpack_public_path__ + "static/media/how-it-works-flow.8fe319a0425e145d8fab84fafbb566b1.svg";
export { ForwardRef as ReactComponent };